import {
  Button,
  Edit,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  useRedirect,
} from "react-admin";
import CancelIcon from "@mui/icons-material/Cancel";

const EditOutletToolbar: React.FC = (props) => {
  const redirect = useRedirect();
  return (
    <Toolbar {...props}>
      <SaveButton />
      <Button
        variant="outlined"
        color="warning"
        label="Annuler"
        size="large"
        onClick={() => redirect("list", "outlets")}
        sx={{ ml: 2, pl: 4 }}
      >
        <CancelIcon />
      </Button>
    </Toolbar>
  );
};

export const OutletEdit = () => (
  <Edit resource="outlets" redirect="list">
    <SimpleForm toolbar={<EditOutletToolbar />}>
      <TextInput disabled source="id" />
      <TextInput
        source="internalCode"
        label="Code interne"
        placeholder="Entrez le code interne de l'exutoire"
        validate={[required("Le code interne est requis")]}
      />
      <TextInput
        source="name"
        label="Nom de l'exutoire"
        placeholder="Entrez le nom de l'exutoire"
        validate={[required("Le nom de l'exutoire est requis")]}
      />
      <TextInput
        source="address"
        label="Adresse"
        placeholder="Entrez l'adresse de l'exutoire"
        validate={[required("L'adresse est requise")]}
      />
      <TextInput
        source="email"
        label="Email"
        placeholder="Entrez l'email de l'exutoire"
        validate={[required("L'email est requis")]}
      />
    </SimpleForm>
  </Edit>
);
